import { call, put, takeLatest } from 'redux-saga/effects';
import { HealthClaim } from '@models/HealthClaim';
import { HealthClaimApi } from '@apis/HealthClaimApi';
import { SagaPayload } from '@utils/typescript';
import {
  healthClaimFetch,
  HealthClaimFetchPayload,
  healthClaimUploadDocuments,
  HealthClaimUploadDocumentsPayload,
  stateUpdate,
  StateUpdatePayload
} from './action';

function* handleHealthClaimFetch({ payload }: SagaPayload<HealthClaimFetchPayload>) {
  const state: StateUpdatePayload = { healthClaim: null };
  try {
    state.healthClaim = (yield call(HealthClaimApi.get, payload)) as HealthClaim;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleHealthClaimUploadDocuments({ payload }: SagaPayload<HealthClaimUploadDocumentsPayload>) {
  try {
    const state: StateUpdatePayload = { healthClaim: null };
    state.healthClaim = (yield call(HealthClaimApi.uploadDocuments, payload)) as HealthClaim;
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(healthClaimFetch, handleHealthClaimFetch);
  yield takeLatest(healthClaimUploadDocuments, handleHealthClaimUploadDocuments);
}
